import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FacilityService } from '../../../services/facility.service';
import { PatientService } from '../../../services/patient.service';
import {
  AUTO_REFILL_PATIENT_PAGE_SIZE,
  AUTO_REFILL_PHARMACY_OPTIONS
} from './auto-refill.constants';
import { buildFacilityOptions } from './auto-refill-facility-picker';
import {
  parsePagedResult,
  patientBirthdateText,
  patientDisplayName,
  patientGenderText,
  pickDto,
  totalPages
} from './auto-refill.utils';

@Component({
  selector: 'app-auto-refill-patient-search',
  templateUrl: './auto-refill-patient-search.component.html',
  styleUrls: ['./auto-refill.component.css']
})
export class AutoRefillPatientSearchComponent implements OnChanges {

  @Input() selectedPharmacyId = 0;
  @Output() selectedPharmacyIdChange = new EventEmitter<number>();
  @Output() patientSelected = new EventEmitter<any>();
  @Output() error = new EventEmitter<string>();

  readonly pharmacyOptions = AUTO_REFILL_PHARMACY_OPTIONS;
  readonly pageSize = AUTO_REFILL_PATIENT_PAGE_SIZE;

  facilityOptions: any[] = [];
  facilitiesLoading = false;
  patientsLoading = false;
  facilityId = 0;
  searchQuery = '';
  patients: any[] = [];
  page = 1;
  totalCount = 0;

  constructor(
    private facilityService: FacilityService,
    private patientService: PatientService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedPharmacyId && !changes.selectedPharmacyId.firstChange) {
      this.facilityId = 0;
      this.page = 1;
      this.loadFacilities();
      this.loadPatients();
    }
  }

  pick = pickDto;
  patientDisplayName = patientDisplayName;
  patientBirthdateText = patientBirthdateText;
  patientGenderText = patientGenderText;

  get totalPages(): number {
    return totalPages(this.totalCount, this.pageSize);
  }

  load(): void {
    this.loadFacilities();
    this.loadPatients();
  }

  onPharmacyChange(): void {
    this.selectedPharmacyIdChange.emit(this.selectedPharmacyId);
    this.facilityId = 0;
    this.page = 1;
    this.loadFacilities();
    this.loadPatients();
  }

  onFacilityChange(): void {
    this.page = 1;
    this.loadPatients();
  }

  loadFacilities(): void {
    if (this.selectedPharmacyId <= 0) {
      this.facilityOptions = [];
      return;
    }
    var self = this;
    this.facilitiesLoading = true;
    this.facilityService.getFacilityDtosList(this.selectedPharmacyId, true).subscribe(
      function (data) {
        self.facilityOptions = buildFacilityOptions(data || []);
        self.facilitiesLoading = false;
      },
      function () {
        self.facilityOptions = [];
        self.facilitiesLoading = false;
        self.error.emit('Could not load nursing homes.');
      }
    );
  }

  loadPatients(): void {
    if (this.selectedPharmacyId <= 0) {
      return;
    }
    var self = this;
    var facilityFilter = this.facilityId > 0 ? this.facilityId : null;
    var search = this.searchQuery && this.searchQuery.trim() ? this.searchQuery.trim() : null;
    this.patientsLoading = true;
    this.patientService.getPatientDtosList(
      this.selectedPharmacyId,
      facilityFilter,
      search,
      this.page,
      this.pageSize,
      true
    ).subscribe(
      function (result) {
        var parsed = parsePagedResult(result);
        self.patients = parsed.items;
        self.totalCount = parsed.totalCount;
        self.patientsLoading = false;
      },
      function () {
        self.patientsLoading = false;
        self.error.emit('Could not load residents.');
      }
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.loadPatients();
  }

  onPageChange(newPage: number): void {
    if (newPage < 1 || newPage > this.totalPages) {
      return;
    }
    this.page = newPage;
    this.loadPatients();
  }

  selectPatient(row: any): void {
    this.patientSelected.emit(row);
  }
}
